:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  --ch-sidebar-inline-size--expanded: auto;
  --ch-sidebar-inline-size--collapsed: auto;
  /**
   * @prop --ch-sidebar__chevron-size:
   * Specifies the expandable button size.
   * @default 0.875em
   */
  --ch-sidebar__chevron-size: 0.875em;
  /**
    * @prop --ch-sidebar__chevron-image-size:
    * Specifies the image size of the expandable button.
    * @default 100%
    */
  --ch-sidebar__chevron-image-size: 100%;
  /**
   * @prop --ch-sidebar__chevron-background-image:
   * Specifies the image of expand button.
   * @default url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)" viewBox="0 0 18 18" fill="none"><path d="M16.5 5L8.7 12.7L1 5" stroke="%23000" stroke-width="1.2" stroke-linecap="round"/></svg>')
   */
  --ch-sidebar__chevron-background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" style="transform:rotate(-90deg)" viewBox="0 0 18 18" fill="none"><path d="M16.5 5L8.7 12.7L1 5" stroke="%23000" stroke-width="1.2" stroke-linecap="round"/></svg>');
  display: grid;
  grid-template-rows: 1fr max-content;
  inline-size: var(--ch-sidebar-inline-size--expanded);
}

:host(.ch-sidebar--collapsed) {
  inline-size: var(--ch-sidebar-inline-size--collapsed);
}

:host([expand-button-position=before]) {
  grid-template-rows: max-content 1fr;
}

.expand-button {
  --ch-sidebar-expand-button-rtl: 1;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  align-items: center;
  justify-content: flex-end;
}
.expand-button::before {
  content: "";
  display: inline-grid;
  inline-size: var(--ch-sidebar__chevron-size);
  block-size: var(--ch-sidebar__chevron-size);
  -webkit-mask: no-repeat center/var(--ch-sidebar__chevron-image-size) var(--ch-sidebar__chevron-background-image);
  background-color: currentColor;
}
.expand-button--expanded-ltr::before {
  transform: rotate(180deg);
}
.expand-button--collapsed {
  justify-content: center;
}
.expand-button--collapsed-rtl::before {
  transform: rotate(180deg);
}